<template>
  <span>
    <v-dialog max-width="500px" persistent v-model="dialog">
      <template #activator="{on}">
        <span v-on="on">
          <slot>
            <v-tooltip bottom>
              {{ $t("global.edit") }}
              <template #activator="{on:tooltip}">
                <v-btn icon v-on="tooltip">
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </slot>
        </span>
      </template>

      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("delegationTask.delegationTask") }}</span>
        </v-card-title>
        <v-card-text>
          <v-form lazy-validation ref="form" v-model="formValid">
            <v-text-field
              :label="$t('delegationTask.tripReasonName')"
              :rules="[max25chars, required]"
              counter
              v-model="contextDelegationTask.name"
            ></v-text-field>

            <v-text-field :label="$t('delegationTask.tripReasonNameEn')" :rules="[max25chars]" counter v-model="contextDelegationTask.name_en"></v-text-field>

            <v-radio-group :mandatory="true" v-model="contextDelegationTask.is_comment_required">
              <v-radio :label="$t('delegationTask.commentNotRequired')" :value="0"></v-radio>
              <v-radio :label="$t('delegationTask.commentRequired10Chars')" :value="1"></v-radio>
            </v-radio-group>

            <v-radio-group :mandatory="true" v-model="contextDelegationTask.is_enabled">
              <v-radio :label="$t('delegationTask.disabledForNew')" :value="0"></v-radio>
              <v-radio :label="$t('delegationTask.enabledForNew')" :value="1"></v-radio>
            </v-radio-group>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="dialog = false" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
          <v-btn :disabled="!formValid || $store.getters['Ajax/loading']" @click.native="save" color="blue darken-1" text>{{ $t("global.save") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
export default {
  name: "DelegationTaskForm",
  props: {
    delegationTask: {
      required: false,
      default: () => ({
        id: null,
        name: "",
        name_en: "",
        is_enabled: 1,
        is_comment_required: 0
      })
    }
  },
  data: () => {
    return {
      contextModel: {
        name: "",
        name_en: "",
        is_enabled: false,
        is_comment_required: false
      },
      contextDelegationTask: null,
      dialog: false,
      formValid: true
    };
  },
  created() {
    this.contextDelegationTask = JSON.parse(JSON.stringify(this.delegationTask));
  },
  methods: {
    max25chars(v) {
      return v == null || v.length <= 25 || this.$t("global.error.nameTooLong");
    },
    required(v) {
      return (v != null && v.length > 0) || this.$t("global.error.required");
    },
    save() {
      if (this.$refs.form.validate()) {
        this.axios
          .post("delegation-task/save", this.contextDelegationTask)
          .then(() => {
            if (this.contextDelegationTask.id == null) {
              this.contextDelegationTask.name = "";
              this.contextDelegationTask.name_en = "";
              this.contextDelegationTask.is_enabled = false;
              this.contextDelegationTask.is_comment_required = false;
            }
            this.$store.dispatch("snackbarPush", {
              text: this.$t("global.saved")
            });
            this.$emit("saved");
            this.dialog = false;
          })
          .catch(resp => {
            console.log(resp.response);
          });
      }
    }
  }
};
</script>

<style scoped></style>
